/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Supervisory_TextInputs */

const en_privacy_supervisory_text = /** @type {(inputs: Privacy_Supervisory_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You have the right to lodge a complaint with a data protection supervisory authority (Art. 77 GDPR). The competent authority for EliteX GbR is:`)
};

const de_privacy_supervisory_text = /** @type {(inputs: Privacy_Supervisory_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehoerde zu beschweren (Art. 77 DSGVO). Die zustaendige Behoerde fuer die EliteX GbR ist:`)
};

const fr_privacy_supervisory_text = /** @type {(inputs: Privacy_Supervisory_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu as le droit d'introduire une réclamation auprès d'une autorité de contrôle de la protection des données (Art. 77 RGPD). L'autorité compétente pour EliteX GbR est :`)
};

const es_privacy_supervisory_text = /** @type {(inputs: Privacy_Supervisory_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tienes derecho a presentar una reclamación ante una autoridad de control de protección de datos (art. 77 RGPD). La autoridad competente para EliteX GbR es:`)
};

const it_privacy_supervisory_text = /** @type {(inputs: Privacy_Supervisory_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai il diritto di presentare un reclamo a un'autorità di controllo per la protezione dei dati (Art. 77 GDPR). L'autorità competente per EliteX GbR è:`)
};

const nl_privacy_supervisory_text = /** @type {(inputs: Privacy_Supervisory_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je hebt het recht een klacht in te dienen bij een toezichthoudende autoriteit voor gegevensbescherming (art. 77 AVG). De bevoegde autoriteit voor EliteX GbR is:`)
};

const pl_privacy_supervisory_text = /** @type {(inputs: Privacy_Supervisory_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masz prawo złożyć skargę do organu nadzorczego ds. ochrony danych (art. 77 RODO). Właściwym organem dla EliteX GbR jest:`)
};

const fi_privacy_supervisory_text = /** @type {(inputs: Privacy_Supervisory_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinulla on oikeus tehdä valitus tietosuojavalvontaviranomaiselle (tietosuoja-asetuksen 77 artikla). EliteX GbR:n toimivaltainen viranomainen on:`)
};

const da_privacy_supervisory_text = /** @type {(inputs: Privacy_Supervisory_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du har ret til at indgive klage til en databeskyttelsestilsynsmyndighed (art. 77, GDPR). Den kompetente myndighed for EliteX GbR er:`)
};

const sv_privacy_supervisory_text = /** @type {(inputs: Privacy_Supervisory_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du har rätt att lämna in ett klagomål till en dataskyddstillsynsmyndighet (art. 77 GDPR). Den behöriga myndigheten för EliteX GbR är:`)
};

/**
* | output |
* | --- |
* | "You have the right to lodge a complaint with a data protection supervisory authority (Art. 77 GDPR). The competent authority for EliteX GbR is:" |
*
* @param {Privacy_Supervisory_TextInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_supervisory_text = /** @type {((inputs?: Privacy_Supervisory_TextInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Supervisory_TextInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_supervisory_text(inputs)
	if (locale === "fr") return fr_privacy_supervisory_text(inputs)
	if (locale === "es") return es_privacy_supervisory_text(inputs)
	if (locale === "it") return it_privacy_supervisory_text(inputs)
	if (locale === "nl") return nl_privacy_supervisory_text(inputs)
	if (locale === "pl") return pl_privacy_supervisory_text(inputs)
	if (locale === "fi") return fi_privacy_supervisory_text(inputs)
	if (locale === "da") return da_privacy_supervisory_text(inputs)
	if (locale === "sv") return sv_privacy_supervisory_text(inputs)
	return en_privacy_supervisory_text(inputs)
});